// Copyright 2022, Imprivata, Inc.  All rights reserved.
import {
 Typography } from 'antd';
import './LandingPage.less';
import { useTranslation } from 'react-i18next';
const LandingPage = () => {
    const { t } = useTranslation();
  return (
    <Typography.Title level={2} className="text-center" data-testid="landing-title">{t('landingPage.use-epic-mychart-to-launch-this-application')}</Typography.Title>
  );
};
export default LandingPage;
